import { call, put, takeLatest, all, select, delay } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchOeeEquipment({ oeeEquipmentParams }) {
  let token = true,
    getToken;
  while (token) {
    try {
      yield put(Actions.setLoader({ showLoader: true }));
      const { data } = yield call(api.get, {
        route: `Telemetry/dashboard/` + oeeEquipmentParams.equipId,
      });
      const oeeEquipmentData = data;
      yield put(Actions.setOeeEquipment({ oeeEquipmentData }));
      yield put(Actions.setLoader({ showLoader: false }));

      yield delay(60000, true);
      getToken = state => state.services.common.getIn(['ajaxCallLoopEquipment']);
      token = yield select(getToken);
    } catch (err) {
      console.warn(err); // Handle exception
    }
  }
}

function* fetchEquipmentTrends({ equipmentTrendParams }) {
  try {
    yield put(Actions.setTrendCycleLoader({ showTrendCycleLoader: true }));
    const { data } = yield call(api.post, {
      route: `Telemetry/equipmenttrends/${equipmentTrendParams.equipId}`,
      data: equipmentTrendParams,
    });
    const equipmentTrends = data;
    yield put(Actions.setEquipmentTrends({ equipmentTrends }));
    yield put(Actions.setTrendCycleLoader({ showTrendCycleLoader: false }));
  } catch (error) {
    yield put(Actions.setTrendCycleLoader({ showTrendCycleLoader: false }));
    console.warn(error); // Handle exception
  }
}
function* fetchAssemblyEquipmentTrends({ equipmentTrendParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `AssemblyLine/assemblyTrend`,
      params: equipmentTrendParams,
    });
    const equipmentTrends = data;
    yield put(Actions.setEquipmentTrends({ equipmentTrends }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error); // Handle exception
  }
}

function* editToolCavity({ toolCavity }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.put, {
      route: 'job/jobtoolcavity',
      data: toolCavity,
    });
    yield put(Actions.fetchToolCavityTable({ jobId: toolCavity.JobId }));
    notification('success', CONSTANT_VARIABLES.CAVITY_UPDATED, '');
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchToolCavityTable(jobId) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `Job/ToolCavityByJobId/${jobId.jobId}`,
    });
    const toolCavityTable = data.toJS();
    yield put(Actions.setToolCavityTable({ toolCavityTable }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    notification('error', err.toString(), '');
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* setPointAnnotation({ annotationParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.put, {
      route: `Telemetry`,
      data: annotationParams,
    });
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    console.warn(error); // Handle exception
    yield put(Actions.setLoader({ showLoader: false }));
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_EQUIPMENT_TRENDS, fetchEquipmentTrends),
    takeLatest(ActionTypes.FETCH_ASSEMBLY_EQUIPMENT_TRENDS, fetchAssemblyEquipmentTrends),
    takeLatest(ActionTypes.FETCH_OEE_EQUIPMENT, fetchOeeEquipment),
    takeLatest(ActionTypes.EDIT_TOOL_CAVITY, editToolCavity),
    takeLatest(ActionTypes.FETCH_TOOL_CAVITY_TABLE, fetchToolCavityTable),
    takeLatest(ActionTypes.SET_POINT_ANNOTATION, setPointAnnotation),
  ]);
}
